<div class="grid-container padding-y-4">
  <div class="grid-row">
    <div class="grid-col flex-auto">
        <legend class="usa-legend usa-legend--large">FRT Comprehensive Shipment Report</legend>
    </div>
  </div>
  <form id="frtComprehensiveFormGroup" role="form" [formGroup]="frtComprehensiveFormGroup" (ngSubmit)="getFRTCompresensiveDetails()">
    <div class="grid-row grid-gap">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="reportingYrSelect">Reporting Calendar Year<abbr title="required"
            class="usa-hint usa-hint--required">*</abbr></label>
        <select id="reportingYrSelect" class="maxw-full usa-select" formControlName='reportingYrSelect' (change)="onReportYrChange($event.target.value)">
          <option hidden value=''>Choose...</option>
          <option *ngFor="let reportingYrSingle of reportingYrList" [value]="reportingYrSingle.value">{{reportingYrSingle.name}}</option>
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="reportingQtrSelect">Reporting Quarter</label>
        <select id="reportingQtrSelect" class="maxw-full usa-select" formControlName='reportingQtrSelect'
          (change)="onReportQtrChange($event.target.value)">
          <option hidden value=''>Choose...</option>
          <option value='1'>Quarter 1 (January - March)</option>
          <option value='2'>Quarter 2 (April - June)</option>
          <option value='3'>Quarter 3 (July - September)</option>
          <option value='4'>Quarter 4 (October - December)</option>
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-1">
        <button type="button" class="usa-button" [disabled]="this.frtComprehensiveFormGroup.invalid" type="submit">Search</button>
      </div>
    </div>
    <ag-grid-angular class="ag-theme-alpine" [columnDefs]="columnsDefs" [gridOptions]="gridOptions" [rowData]="rowData"
      [suppressDragLeaveHidesColumns]="true" (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </form>
</div>
